module.exports = __webpack_public_path__ + "static/media/maddie.0979614d.png";